/* ==============================
   Foxpost csomagautomata választó
   Hivatalos iframe widget: https://cdn.foxpost.hu/apt-finder/v1/app/
   ============================== */

$(function () {
	function clearFoxpostSelection() {
		$('#foxpost_parcelshop_id, #foxpost_parcelshop_place_id, #foxpost_parcelshop_name, #foxpost_parcelshop_address').val('');
		$('#foxpostPickupName').text(window.Lang.co_no_parcel);
		$('#foxpostPickupAddress').text('');
		$(document).trigger('foxpostParcelShopSelected');
	}

	function getModalEl() {
		return document.getElementById('foxpostPickerModal');
	}

	$(document).on('change', '#co_country', function () {
		if ($('#foxpost_parcelshop_id').val()) {
			clearFoxpostSelection();
		}
	});

	$(document).on('click', '#foxpostPickupSelectBtn', function () {
		var el = getModalEl();
		if (!el || typeof bootstrap === 'undefined') {
			console.error('Foxpost modal (#foxpostPickerModal) vagy a Bootstrap JS nem elérhető.');
			return;
		}
		bootstrap.Modal.getOrCreateInstance(el).show();
	});

	window.addEventListener('message', function (event) {
		if (event.origin !== 'https://cdn.foxpost.hu') {
			return;
		}

		var parcelShop;
		try {
			parcelShop = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
		} catch (error) {
			return;
		}

		if (!parcelShop || !parcelShop.name || (!parcelShop.operator_id && !parcelShop.place_id)) {
			return;
		}

		var identifier = parcelShop.operator_id || String(parcelShop.place_id);
		var address = parcelShop.address || [parcelShop.zip, parcelShop.city, parcelShop.street].filter(Boolean).join(' ');

		$('#foxpost_parcelshop_id').val(identifier);
		$('#foxpost_parcelshop_place_id').val(parcelShop.place_id || '');
		$('#foxpost_parcelshop_name').val(parcelShop.name);
		$('#foxpost_parcelshop_address').val(address);
		$('#foxpostPickupName').text(parcelShop.name);
		$('#foxpostPickupAddress').text(address);

		var modalEl = getModalEl();
		if (modalEl && typeof bootstrap !== 'undefined') {
			var instance = bootstrap.Modal.getInstance(modalEl);
			if (instance) {
				instance.hide();
			}
		}

		$(document).trigger('foxpostParcelShopSelected');
	}, false);
});

